import { Injectable, NgModule } from '@angular/core';
import { DataApiService, BaseService } from '@xpo-ltl/data-api';
import { ConfigManagerService, CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import { PayloadType, CBOType } from '@xpo-ltl/sdk-common';

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@xpo-ltl/data-api';
import * as ɵngcc2 from '@xpo-ltl/config-manager';
class CarrierManagementApiService extends BaseService {
    /**
     * @param {?} dataApiService
     * @param {?} configManager
     */
    constructor(dataApiService, configManager) {
        super();
        this.dataApiService = dataApiService;
        this.configManager = configManager;
    }
    /**
     * Health check URL. Responds with success message if the service is running.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    healthCheck(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/health-check'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List of resources.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    options(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/options'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Details of user invoking the API.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    loggedInUser(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/appusers/logged-in-user'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation receives invoice data sent by a carrier and stores the invoice for later processing.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid carrier ID, InvoiceStaging, and at least one InvoiceItemStaging is included with the request.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the carrier invoice and line item(s) are created in the system.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createCarrierInvoice(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/carriers/{carrierId}/invoices'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation creates carrier tender and tender details.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Valid Tender data is provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the carrier tender is created.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createCarrierTender(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/tenders'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation creates the fuel surcharge in CMS based on the US Energy Information Administraion.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Valid FuelSurchage details are provided including the release date for the fuel surcharge.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the Fuel Surchage record is created.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    createFuelSurcharge(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/fuel-surcharges'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation gets details for a partner carrier.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid carrierId or scacCd must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the input is valid, then the corresponding CarrierMaster will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getCarrierDetails(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/carrier-details'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves the carrier location and its location SICs based on the carrierId and locationId provided.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid carrierId and locationId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the corresponding carrier location and location SICs, if any, will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getCarrierLocation(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/locations/{locationId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves the carrier location and its location SICs based on the customerNbr provided.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid customerNbr must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the corresponding carrier location and location SICs, if any, will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getCarrierLocationByCustomerNbr(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/locations/customers/{customerNbr}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns the tender header and tender details for a tender ID.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid tenderId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the corresponding Tender and a list of TenderDetail will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getCarrierTender(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/tenders/{tenderId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation retrieves a fuel surcharge for CMS.  It gets national and west coast fuel costs using US Energy Information Administration (EIA) APIs.
     * <br/>
     * <br/>Pre-condition:
     * <br/>None
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the EIA APIs are successful, then the fuel costs will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getFuelSurcharge(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/fuel-surcharges'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation gets rate information for a subservice lane.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid foreignScacCd, originSicCd, loadDestinationSicCd, trailerNbr, and scheduledDepartDate must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If the input values are valid, then details about the subservice rate will be returned. If a rate cannot be found for a lane an average for the carrier will be returned
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getSubserviceRate(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/carriers/{foreignScacCd}/origins/{originSicCd}/destinations/{loadDestinationSicCd}/rates'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists details for carriers.  Optionally it can select locations by sicCd and a list of
     * <br/>		carrierDetailCds to include location and location SIC information for each carrier.  When carrierDetailCds are null or 'Carriers', then only a list of carriers will be returned.  When carrierDetailCds are 'Locations', then the list of carriers, locations, and location SICs are returned.  The sicCd parameter can also be used to further qualify the 'Location' result.
     * <br/>
     * <br/>Pre-condition:
     * <br/>None
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then a list of all the existing carriers will be returned along with any carrier locations and location SICs for each carrier that may exist.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listCarriers(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/carriers'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation lists tender header and tender details using either tender, trip, or route IDs.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. At least one valid tenderId, tripInstId, or routeInstId must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the corresponding list of Tenders including TenderDetails will be returned.
     * <br/>2. Otherwise an appropriate error message will be returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listCarrierTenders(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/tender-lists'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation returns all possible matching Pull records for a trailer.
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. A valid scac, trailer, originSic, destSic, and statusIds OR booking number must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the list of matching Pulls for the trailer are returned.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listTrailerPulls(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/trailers/pulls'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation performs insert and update actions against a CMS carrier along with insert, update, and delete actions against their locations and location SICs.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid list of carriers is provided.  Carrier Location and Location SICs are not required for this service, but must be valid when included in the request.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then any inserts, updates, or deletions to the carriers, their locations, and location SICs are applied.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    maintainCarriersAndLocations(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/carriers-and-locations'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates carrier tender and tender details.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. Valid Tender data are provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the carrier tender is updated.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateCarrierTender(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/tenders/{tenderId}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates pull comments in CMS using the pull ID once the user enters some comment for Approve/Decline.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. A valid pull ID and comments OR booking number must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the comments are updated.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updatePullComments(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/pull-comments'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation updates pulls in CMS based on the pull ID supplied.
     * <br/>
     * <br/>Pre-condition:
     * <br/>1. At least one valid Pull with a valid pull ID must be provided.
     * <br/>
     * <br/>Post-conditions:
     * <br/>1. If successful, then the pulls are updated.
     * <br/>2. Otherwise an appropriate error message is returned.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateTrailerPulls(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/pulls'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Check changed documents against registered filters for tender-notifications
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    changesFeedTenderNotifications(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/tender-notifications/changes'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Register a filter with XRT for TenderNotifications
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    registerFilterTenderNotifications(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/tender-notifications/filters/register'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Unregister a filter with XRT for TenderNotifications
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    unregisterFilterTenderNotifications(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/tender-notifications/filters/unregister'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Delete expired messages in the queue
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteExpiredMessages(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/messages'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * This operation returns counts for the number of ensembles in each of the status cd values.
     * <br/>Pre-conditions:
     * <br/>1. Input search criteria may be provided.
     * <br/>Post-condition:
     * <br/>1. Counts for each ensemble status are returned.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getEnsembleStatusCounts(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/counts/{fromTmst}/{toTmst}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns counts for PubSub statuses
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getPubSubStatusCounts(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}/summary/counts/{fromTmst}/{toTmst}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns counts for the number of messages pending in the queue.
     * <br/>Pre-conditions:
     * <br/>1. Queue name is provided.
     * <br/>Post-condition:
     * <br/>1. Count of all messages in ready and wait statuses
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getQueuePendingCount(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/counts/pending'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation return Status of Given Subscription
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getSubscription(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation returns a count of number of undelivered messages in this PubSub subscription
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getUndeliveredMessages(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}/undelivered/counts'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * This operation updates one or more SUSPENDED Ensemble execution row to a status of KILLED, in order to indicate it is has been forced to stop processing.
     * <br/>Pre-conditions:
     * <br/>1. One or more Ensemble Instance Ids that is in a status of SUSPENDED is supplied and valid.
     * <br/>Post-condition:
     * <br/>1. Ensemble record(s) updated to a Status of KILLED.
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    killEnsemble(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/ensembles/kill'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * List the channels.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listChannels(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/channels/'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List all expired messages in the queue
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listExpiredMessages(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/messages/{enqueueFromTmst}/{enqueueToTmst}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List the queues.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listQueues(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List the Pub/Sub subscriptions.
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listSubscriptions(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Replay a message in expired status
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    replayMessage(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/messages/{messageId}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * This operation Restarts a STARTED or NOT_STARTED Ensemble execution based on input Ensemble Instance Id.
     * <br/>Pre-conditions:
     * <br/>1. Input Ensemble Instance Id is supplied and valid.
     * <br/>Post-condition:
     * <br/>1. STARTED or NOT_STARTED Ensemble execution status is updated to STARTED and execution is initiated; if any Minuets exist for the Ensemble, those are initiated in sequence and status updates are performed.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    restartEnsemble(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/ensembles/{ensembleInstId}/restart'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * This operation Resumes a SUSPENDED Ensemble execution based on input Ensemble Instance Id.
     * <br/>Pre-conditions:
     * <br/>1. Input Ensemble Instance Id is supplied and valid.
     * <br/>Post-condition:
     * <br/>1. SUSPENDED Ensemble execution status is updated to STARTED and execution is initiated; if any Minuets exist for the Ensemble, those are initiated in sequence and status updates are performed.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    resumeEnsemble(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/ensembles/{ensembleInstId}/resume'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Start an API Channel.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startChannel(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/channels/{channelName}/start'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Start a queue.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startQueue(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/start'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Start or restart a PubSub subscription.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startSubscription(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}/start'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Stop an API Channel.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    stopChannel(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/channels/{channelName}/stop'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Stop a queue. Stopping a queue will only stop the dequeuing process, it will continue to enqueue
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    stopQueue(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/queues/{queueName}/stop'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Stop a queue. Stopping a queue will only stop the dequeuing process, it will continue to enqueue
     * @param {?} request
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    stopQueueWebhook(request, pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/webhooks/queues/{queueName}/stop'), {
            pathParams: pathParams,
            queryParams: queryParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Stop a PubSub subscription.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    stopSubscription(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/pubsub/subscriptions/{subscriptionId}/stop'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.put(apiRequest);
    }
    /**
     * Export documents from elastic index
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. Filter criteria is supplied
     * <br/>
     * <br/>Post-condition:
     * <br/>1. All documents matching the filter will be exported as CSV or Excel format
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    exportEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/exports'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Aggregations from elastic index
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. Filter criteria is supplied
     * <br/>2. One of more fields are supplied
     * <br/>
     * <br/>Post-condition:
     * <br/>1. Aggregations for each supplied field
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listAggregationsEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/aggregations'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Search documents from elastic index
     * <br/>
     * <br/>Pre-conditions:
     * <br/>1. Filter criteria is supplied
     * <br/>
     * <br/>Post-condition:
     * <br/>1. Documents matching the filter will be returned
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    searchEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/searches'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Check changed documents against registered filters for ensemble-state-unfiltered
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    changesFeedEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/changes'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Register a filter with XRT for EnsembleStateUnfiltered
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    registerFilterEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/filters/register'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Unregister a filter with XRT for EnsembleStateUnfiltered
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    unregisterFilterEnsembleStateUnfiltered(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/ensemble-state-unfiltered/filters/unregister'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Delete Elastic document for EnsembleState
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    deleteElasticDocumentEnsembleState(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/elastic/ensemble-state-unfiltered/_doc/{instId}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * Get Elastic document from EnsembleState index for given primary key
     * @param {?} pathParams
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getElasticDocumentEnsembleState(pathParams, queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/elastic/ensemble-state-unfiltered/_doc/{instId}'), {
            pathParams: pathParams,
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Get document count from EnsembleState index
     * @param {?} queryParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    getElasticDocumentEnsembleStateCount(queryParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/elastic/ensemble-state-unfiltered/_count'), {
            queryParams: queryParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Update Elastic document for EnsembleState
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    updateElasticDocumentEnsembleState(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/elastic/ensemble-state-unfiltered/_doc/{instId}/_update'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * List all ensemble configurations
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listEnsembleConfigurations(dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/configurations'), {}, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * List the timers.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    listTimerEnsembles(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/timer-ensembles/{name}/timers'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.get(apiRequest);
    }
    /**
     * Start a timer.
     * @param {?} request
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startTimerEnsemble(request, pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/timers/{name}'), {
            pathParams: pathParams,
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * Stop a timer.
     * @param {?} pathParams
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    stopTimerEnsemble(pathParams, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/timers/{name}'), {
            pathParams: pathParams
        }, dataOptions, httpOptions);
        return this.dataApiService.delete(apiRequest);
    }
    /**
     * Start ensemble by invoking API
     * <br/>        	PRE-CONDITION:
     * <br/>        		valid channelName is required
     * <br/>        		valid payload is required
     * <br/>        	POST-CONDITION:
     * <br/>        		Ensemble is started and an id is returned in the response
     * <br/>
     * @param {?} request
     * @param {?=} dataOptions
     * @param {?=} httpOptions
     * @return {?}
     */
    startTenderChEnsemble(request, dataOptions, httpOptions) {
        const /** @type {?} */ apiRequest = this.generateApiRequest(this.getUrl('/symphony-ensemble/channels/CMS_TENDER_CH/ensembles'), {
            body: request
        }, dataOptions, httpOptions);
        return this.dataApiService.post(apiRequest);
    }
    /**
     * @return {?}
     */
    getEndPoint() {
        return this.configManager.getSetting(CarrierManagementApiService.CarrierManagementApiEndpoint);
    }
}
CarrierManagementApiService.ɵfac = function CarrierManagementApiService_Factory(t) { return new (t || CarrierManagementApiService)(ɵngcc0.ɵɵinject(ɵngcc1.DataApiService), ɵngcc0.ɵɵinject(ɵngcc2.ConfigManagerService)); };
CarrierManagementApiService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: CarrierManagementApiService, factory: CarrierManagementApiService.ɵfac });
CarrierManagementApiService.CarrierManagementApiEndpoint = 'carriermanagementApiEndpoint';
/** @nocollapse */
CarrierManagementApiService.ctorParameters = () => [
    { type: DataApiService },
    { type: ConfigManagerService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarrierManagementApiService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc1.DataApiService }, { type: ɵngcc2.ConfigManagerService }]; }, null); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
const ɵ0 = { configFileUrl: './assets/config.json' };
class SdkCarrierManagementModule {
}
SdkCarrierManagementModule.ɵfac = function SdkCarrierManagementModule_Factory(t) { return new (t || SdkCarrierManagementModule)(); };
SdkCarrierManagementModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: SdkCarrierManagementModule });
SdkCarrierManagementModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ providers: [
        CarrierManagementApiService,
        { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
    ], imports: [[
            ConfigManagerModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SdkCarrierManagementModule, [{
        type: NgModule,
        args: [{
                imports: [
                    ConfigManagerModule
                ],
                providers: [
                    CarrierManagementApiService,
                    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: ɵ0 },
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(SdkCarrierManagementModule, { imports: function () { return [ConfigManagerModule]; } }); })();

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */
/**
 * Path parameters which are used to retrieve rate information for a subservice lane.
 */
class CreateCarrierInvoicePath {
    constructor() {
        /**
         * The unique identifier associated with a specific carrier agent.
         * Required: true
         * Array: false
         */
        this.carrierId = undefined;
    }
}
/**
 * Request containing header and line item details for one carrier invoice.
 */
class CreateCarrierInvoiceRqst {
    constructor() {
        /**
         * Invoice header information about the invoice from the carrier.
         * Required: true
         * Array: false
         */
        this.carrierInvoice = undefined;
        /**
         * Invoice line item details corresponding to the carrier invoice.
         * Required: true
         * Array: true
         */
        this.carrierInvoiceLineItems = undefined;
    }
}
/**
 * Request to create a carrier tender.
 */
class CreateCarrierTenderRqst {
    constructor() {
        /**
         * The carrier tender information.
         * Required: true
         * Array: false
         */
        this.tender = undefined;
    }
}
/**
 * Response to the request to create a carrier tender.
 */
class CreateCarrierTenderResp {
    constructor() {
        /**
         * The carrier tender information.
         * Required: false
         * Array: false
         */
        this.tender = undefined;
    }
}
/**
 * Request to create a fuel surcharge.
 */
class CreateFuelSurchargeRqst {
    constructor() {
        /**
         * The details for the fuel surcharge which will be used to create the record.
         * Required: true
         * Array: false
         */
        this.fuelCharge = undefined;
    }
}
/**
 * Request to get details for a partner carrier.
 */
class GetCarrierDetailsQuery {
    constructor() {
        /**
         * The unique identifer for the carrier.
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * The Standard Carrier Alpha Code is a unique two-to-four-letter code which is used to identify the carrier.
         * Required: false
         * Array: false
         */
        this.scacCd = undefined;
    }
}
/**
 * Response to the request to get details for a partner carrier.
 */
class GetCarrierDetailsResp {
    constructor() {
        /**
         * The details for the cartage carrier.
         * Required: false
         * Array: false
         */
        this.carrierMaster = undefined;
    }
}
/**
 * Path parameters which are used to retrieve a carrier location.
 */
class GetCarrierLocationPath {
    constructor() {
        /**
         * The unique identifier for a carrier location.
         * Required: true
         * Array: false
         */
        this.locationId = undefined;
    }
}
/**
 * Response to the request to retrieve a carrier location.
 */
class GetCarrierLocationResp {
    constructor() {
        /**
         * The details for the cartage carrier location.
         * Required: false
         * Array: false
         */
        this.carrierLocation = undefined;
    }
}
/**
 * The path parameter to retrieve a carrier location by customerNbr.
 */
class GetCarrierLocationByCustomerNbrPath {
    constructor() {
        /**
         * The unique identifier of the customer.
         * Required: true
         * Array: false
         */
        this.customerNbr = undefined;
    }
}
/**
 * Response to the request to retrieve a carrier location.
 */
class GetCarrierLocationByCustomerNbrResp {
    constructor() {
        /**
         * The details for the cartage carrier location.
         * Required: false
         * Array: false
         */
        this.carrierLocation = undefined;
    }
}
/**
 * Path parameter which is used to get the header and details for a partner carrier shipment tender.
 */
class GetCarrierTenderPath {
    constructor() {
        /**
         * The unique identifer that represents the tender for a group of shipments.
         * Required: false
         * Array: false
         */
        this.tenderId = undefined;
    }
}
/**
 * Response to the request to get the header and details for a partner carrier shipment tender.
 */
class GetCarrierTenderResp {
    constructor() {
        /**
         * The carrier tender information.
         * Required: false
         * Array: false
         */
        this.tender = undefined;
    }
}
/**
 * Response to the request to retrieve a fuel surchage.
 */
class GetFuelSurchargeResp {
    constructor() {
        /**
         * The details for the fuel surcharge.
         * Required: false
         * Array: false
         */
        this.fuelSurcharge = undefined;
    }
}
/**
 * Path parameters which are used to retrieve rate information for a subservice lane.
 */
class GetSubserviceRatePath {
    constructor() {
        /**
         * The identifer for the carrier.
         * Required: true
         * Array: false
         */
        this.foreignScacCd = undefined;
        /**
         * The sic code for the origin service center.
         * Required: true
         * Array: false
         */
        this.originSicCd = undefined;
        /**
         * The sic code for the destination service center.
         * Required: true
         * Array: false
         */
        this.loadDestinationSicCd = undefined;
    }
}
class GetSubserviceRateQuery {
    constructor() {
        /**
         * The number associated with the trailer.
         * Required: true
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The date for the rate in question.
         * Required: true
         * Array: false
         */
        this.scheduledDepartDate = undefined;
    }
}
/**
 * Response to the request to retrieve rate information for a subservice lane.
 */
class GetSubserviceRateResp {
    constructor() {
        /**
         * The number associated with the trailer.
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         * The identifier for the lane.
         * Required: false
         * Array: false
         */
        this.laneId = undefined;
        /**
         * The identifier for the pull.
         * Required: false
         * Array: false
         */
        this.pullId = undefined;
        /**
         * The number of miles between the origin and destination.
         * Required: false
         * Array: false
         */
        this.mileage = undefined;
        /**
         * The rate charged for the lane and carrier.
         * Required: false
         * Array: false
         */
        this.rate = undefined;
        /**
         * The current fuel surcharge.
         * Required: false
         * Array: false
         */
        this.fuelSurcharge = undefined;
    }
}
/**
 * Query parameters which are used to list carriers and their locations and location SIC details.
 */
class ListCarriersQuery {
    constructor() {
        /**
         * The service center identification code which is used to select only the locations for that SIC that may exist for each carrier.
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The codes which determine the types of information which will be included in the response.
         * Required: false
         * Array: true
         */
        this.carrierDetailCds = undefined;
    }
}
/**
 * Response to the request to list carriers and their locations and location SIC details.
 */
class ListCarriersResp {
    constructor() {
        /**
         * The list of information about each carrier and any location details for it.
         * Required: false
         * Array: true
         */
        this.carrierMasterLocations = undefined;
    }
}
/**
 * Request to get the headers and details for partner carrier shipment tenders.
 */
class ListCarrierTendersRqst {
    constructor() {
        /**
         * The list of unique identifers that represents the tenders for a group of shipments.
         * Required: false
         * Array: true
         */
        this.tenderIds = undefined;
        /**
         * The list of unique identifers for trips that are associated with a group of tendered shipments.
         * Required: false
         * Array: true
         */
        this.tripInstIds = undefined;
        /**
         * The list of unique identifers for routes on trips that are associated with a group of tendered shipments.
         * Required: false
         * Array: true
         */
        this.routeInstIds = undefined;
    }
}
/**
 * Response to the request to get headers and details for partner carrier shipment tenders.
 */
class ListCarrierTendersResp {
    constructor() {
        /**
         * The list of carrier tender information.
         * Required: false
         * Array: true
         */
        this.tenders = undefined;
    }
}
/**
 * Query parameters which are used to list the matching Pulls for a trailer.
 */
class ListTrailerPullsQuery {
    constructor() {
        /**
         * The first four letters of the trailer number.
         * Required: false
         * Array: false
         */
        this.scac = undefined;
        /**
         * The number associated with the trailer.
         * Required: false
         * Array: false
         */
        this.trailer = undefined;
        /**
         * The origin of the trailer.
         * Required: false
         * Array: false
         */
        this.originSic = undefined;
        /**
         * The destination of the trailer.
         * Required: false
         * Array: false
         */
        this.destSic = undefined;
        /**
         * The status identifiers for the pulls.
         * Required: false
         * Array: true
         */
        this.statusIds = undefined;
        /**
         * The load release number which is represented by seven characters in the CMS database unlike in OPS_TRAILER_LOAD where it is eight.
         * Required: false
         * Array: false
         */
        this.loadRelease = undefined;
        /**
         * The booking number for the trailer.
         * Required: false
         * Array: false
         */
        this.booking = undefined;
        /**
         * The loading operation (shift code) for the trailer.
         * Required: false
         * Array: false
         */
        this.loadingOperation = undefined;
        /**
         * The scheduled departure date time for the trailer.
         * Required: false
         * Array: false
         */
        this.scheduledDepart = undefined;
    }
}
/**
 * Response to the request to list the matching Pulls for a trailer.
 */
class ListTrailerPullsResp {
    constructor() {
        /**
         * The list of matching Pulls for the trailer.
         * Required: false
         * Array: true
         */
        this.pulls = undefined;
    }
}
/**
 * Request to maintain carriers and their locations.
 */
class MaintainCarriersAndLocationsRqst {
    constructor() {
        /**
         * The list of information about each carrier and any location details for it.
         * Required: true
         * Array: true
         */
        this.carrierMasterLocations = undefined;
    }
}
/**
 * Response to the request to maintain carriers and their locations.
 */
class MaintainCarriersAndLocationsResp {
    constructor() {
        /**
         * The list of information about each carrier and any location details for it.
         * Required: false
         * Array: true
         */
        this.carrierMasterLocations = undefined;
    }
}
/**
 * Path parameter which is used to update a carrier tender.
 */
class UpdateCarrierTenderPath {
    constructor() {
        /**
         * The unique identifer that represents the tender for a group of shipments.
         * Required: true
         * Array: false
         */
        this.tenderId = undefined;
    }
}
/**
 * Request to update a carrier tender.
 */
class UpdateCarrierTenderRqst {
    constructor() {
        /**
         * The carrier tender information.
         * Required: true
         * Array: false
         */
        this.tender = undefined;
    }
}
/**
 * Response to the request to update a carrier tender.
 */
class UpdateCarrierTenderResp {
    constructor() {
        /**
         * The carrier tender information.
         * Required: false
         * Array: false
         */
        this.tender = undefined;
    }
}
/**
 * Path parameters which are used to update the comments on tblpullcomments.
 */
class UpdatePullCommentRqst {
    constructor() {
        /**
         * The pull identifier, which is the primary key for the tblPulls table.
         * Required: false
         * Array: false
         */
        this.pullId = undefined;
        /**
         * The booking number for the trailer.
         * Required: false
         * Array: false
         */
        this.booking = undefined;
        /**
         * The approve/decline comments in CMS.
         * Required: false
         * Array: false
         */
        this.comments = undefined;
    }
}
/**
 * Request to update pulls.
 */
class UpdateTrailerPullsRqst {
    constructor() {
        /**
         * The list of Pulls to be updated.
         * Required: true
         * Array: true
         */
        this.pulls = undefined;
    }
}
/**
 * Response to the request to update pulls.
 */
class UpdateTrailerPullsResp {
    constructor() {
        /**
         * The list of updated Pulls.
         * Required: false
         * Array: true
         */
        this.pulls = undefined;
    }
}
/**
 * Invoice data sent by an external third party cartage carrier.
 */
class CarrierInvoice {
    constructor() {
        /**
         * The invoice identifier used by the carrier.
         * Required: false
         * Array: false
         */
        this.carrierInvoiceId = undefined;
        /**
         * The date of the invoice.
         * Required: false
         * Array: false
         */
        this.invoiceDate = undefined;
    }
}
/**
 * Invoice line item information sent by an external third party cartage carrier.
 */
class CarrierInvoiceLineItem {
    constructor() {
        /**
         * The internal identifier of the route for the line item.
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * The internal identifier of the shipment for the line item.
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * The date and time at which the service described by this line item was performed.
         * Required: false
         * Array: false
         */
        this.occurredDateTime = undefined;
        /**
         * The charge type, which is MAIN or ACCESSORIAL
         * Required: false
         * Array: false
         */
        this.chargeTypeCd = undefined;
        /**
         * The description of the accessorial.
         * Required: false
         * Array: false
         */
        this.accessorialCd = undefined;
        /**
         * The number of units described by the line item.
         * Required: false
         * Array: false
         */
        this.unitCount = undefined;
        /**
         * The unit of measure of the units such as EACH, MINUTE, or CWT.
         * Required: false
         * Array: false
         */
        this.unitUnitOfMeasure = undefined;
        /**
         * The amount charged per unit.
         * Required: false
         * Array: false
         */
        this.unitChargeAmount = undefined;
        /**
         * The total amount charged.
         * Required: false
         * Array: false
         */
        this.totalChargeAmount = undefined;
        /**
         * The currency code of the charge. Permitted values: USD and CDN.
         * Required: false
         * Array: false
         */
        this.chargeCurrencyCd = undefined;
        /**
         * The free form text describing the line item.
         * Required: false
         * Array: false
         */
        this.remark = undefined;
        /**
         * The business key provided by the carrier.
         * Required: false
         * Array: false
         */
        this.routeName = undefined;
        /**
         * The business key provided by the carrier.
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * The unique identifier for the trip that contained the shipment or pickup that is represented on this line item.
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         * The unique identifier of the pickup request.
         * Required: false
         * Array: false
         */
        this.pickupRequestId = undefined;
        /**
         * The sequence number that forms part of the unique key with the pickup request ID that identifies a specific line item.
         * Required: false
         * Array: false
         */
        this.pickupShipmentId = undefined;
        /**
         * Identifies the order in which a pickup request was received.  Made up of the day the call was received for the pickup and sequential number.  Used as a business key for a specific pickup request.
         * Required: false
         * Array: false
         */
        this.callNbr = undefined;
    }
}
/**
 * Information about the carrier and any location details for it.
 */
class CarrierMasterLocation {
    constructor() {
        /**
         * The details for the cartage carrier.
         * Required: false
         * Array: false
         */
        this.carrierMaster = undefined;
        /**
         * The cartage carrier locations, including any location SICs.
         * Required: false
         * Array: true
         */
        this.carrierLocations = undefined;
    }
}
/**
 * Carrier Shipment status detail.
 */
class ShipmentExternalStatus {
    constructor() {
        /**
         * The shipment status from the carrier.
         * Required: true
         * Array: false
         */
        this.statusCd = undefined;
        /**
         * The cross-reference shipment identifier from the carrier.
         * Required: true
         * Array: false
         */
        this.carrierShipmentId = undefined;
        /**
         * The business identifier for the shipment.
         * Required: true
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * The internal key identifying the shipment.
         * Required: true
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * The number of pieces affected by the exception.
         * Required: true
         * Array: false
         */
        this.exceptionPiecesCount = undefined;
        /**
         * The free form remarks describing the exception.
         * Required: true
         * Array: false
         */
        this.exceptionRemark = undefined;
        /**
         * The date and time when the status event occurred.
         * Required: true
         * Array: false
         */
        this.occuredDateTime = undefined;
        /**
         * The latitude where the status event occurred.
         * Required: true
         * Array: false
         */
        this.occuredLatitudeNbr = undefined;
        /**
         * The longitude where the status event occurred.
         * Required: true
         * Array: false
         */
        this.occuredLongitudeNbr = undefined;
    }
}
/**
 * Snapshot of a record modified by a transaction event.
 */
class CarrierManagementEventSnapshot {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.tenderSnapshot = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.tenderDetailSnapshot = undefined;
    }
}
/**
 * Payload used to create a carrier tender via the API channel.
 */
class CreateTenderPayload {
    constructor() {
        /**
         * The unique identifier associated with the trip.
         * Required: true
         * Array: false
         */
        this.tripInstId = undefined;
    }
}
/**
 * The change feed record type for shipments tendered by a third party.  This change feed notifies the PnD user of a change in shipment status.
 */
class TenderNotification {
    constructor() {
        /**
         * The code associated with the service center where the shipments were tendered to the cartage carrier.
         * Required: true
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * The actual name of the route used by the third-party cartage carrier for routing the shipments tendered to them.
         * Required: false
         * Array: false
         */
        this.routeName = undefined;
        /**
         * The name of the cartage carrier from the carrier master.
         * Required: false
         * Array: false
         */
        this.carrierName = undefined;
        /**
         * The system generated identifier, which is part of the primary key.
         * Required: true
         * Array: false
         */
        this.tenderId = undefined;
        /**
         * The internal primary key of the trip in the PnD system.
         * Required: true
         * Array: false
         */
        this.tripId = undefined;
        /**
         * The internal primary key of the route in the PnD system.
         * Required: true
         * Array: false
         */
        this.routeId = undefined;
        /**
         * A derived tender status based on combinations of the tender detail status of each tendered shipment on the trip.
         * Required: false
         * Array: false
         */
        this.carrierTenderGroupStatusCd = undefined;
        /**
         * The list of messages which each describe a failure or rejection in the tender process.  They are formatted for display in a user interface.
         * Required: false
         * Array: true
         */
        this.tenderMessages = undefined;
        /**
         * The list of shipments tendered to the carrier.
         * Required: false
         * Array: true
         */
        this.tenderDetails = undefined;
    }
}
class CBOCmsPullType {
    constructor() {
        /**
         * The unique identifier of the pull schedule.
         * Required: true
         * Array: false
         */
        this.Pull_ID = undefined;
        /**
         * The service center identification code for the pull origin.
         * Required: true
         * Array: false
         */
        this.OrigSIC = undefined;
        /**
         * The service center identification code for the pull destination.
         * Required: true
         * Array: false
         */
        this.DestSIC = undefined;
        /**
         * The SCAC code for the carrier providing the pull.
         * Required: true
         * Array: false
         */
        this.SCAC = undefined;
        /**
         * The schedule departure date for the pull.
         * Required: true
         * Array: false
         */
        this.ScheduleDepartDate = undefined;
        /**
         * The booking reference number for the pull.
         * Required: true
         * Array: false
         */
        this.BookingNumber = undefined;
        /**
         * The shift code for which shipments are loaded onto the trailer.
         * Required: true
         * Array: false
         */
        this.LoadingOperation = undefined;
        /**
         * The trailer number for the carrier equipment.
         * Required: true
         * Array: false
         */
        this.TrailerNumber = undefined;
        /**
         * The indicator that determines whether a pull has been cancelled.
         * Required: true
         * Array: false
         */
        this.CancelInd = undefined;
        /**
         * The action code that is associated with the schedule.
         * Required: true
         * Array: false
         */
        this.Action = undefined;
        /**
         * The date and time the schedule was created.
         * Required: true
         * Array: false
         */
        this.CreateTimestamp = undefined;
        /**
         * The date and time the schedule was last updated.
         * Required: true
         * Array: false
         */
        this.UpdateTimestamp = undefined;
    }
}
class TenderNotificationFilter {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
    }
}
class TenderNotificationChangeRecord {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tenderId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.record = undefined;
    }
}
/**
 * Request for register
 */
class RegisterFilterTenderNotificationsRqst {
    constructor() {
        /**
         * Id of the  user. For future use.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Connection token
         * Required: false
         * Array: false
         */
        this.connectionToken = undefined;
        /**
         * The filter to register
         * Required: false
         * Array: false
         */
        this.filter = undefined;
    }
}
/**
 * Response for register filter
 */
class RegisterFilterTenderNotificationsResp {
    constructor() {
        /**
         * Hash for the filter
         * Required: false
         * Array: false
         */
        this.filterHash = undefined;
        /**
         * Duration for the API execution
         * Required: false
         * Array: false
         */
        this.duration = undefined;
        /**
         * Number of registrations created
         * Required: false
         * Array: false
         */
        this.numberOfRegistrations = undefined;
    }
}
/**
 * Request for register
 */
class UnregisterFilterTenderNotificationsRqst {
    constructor() {
        /**
         * Id of the  user. For future use.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Connection token
         * Required: false
         * Array: false
         */
        this.connectionToken = undefined;
        /**
         * The hash of the filter to unregister. Filter has is returned by registerFilter
         * Required: false
         * Array: false
         */
        this.filterHash = undefined;
    }
}
/**
 * Request for changes feed
 */
class ChangesFeedTenderNotificationsRqst {
    constructor() {
        /**
         * A list of document Ids
         * Required: false
         * Array: true
         */
        this.changedDocumentIds = undefined;
        /**
         * A list of changed documents
         * Required: false
         * Array: true
         */
        this.changedDocuments = undefined;
    }
}
/**
 * Path parameters for get Ensemble status counts
 */
class GetEnsembleStatusCountsPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
        /**
         * From timestamp
         * Required: true
         * Array: false
         */
        this.fromTmst = undefined;
        /**
         * To timestamp
         * Required: true
         * Array: false
         */
        this.toTmst = undefined;
    }
}
/**
 * Response to the request to get Ensemble status counts
 */
class GetEnsembleStatusCountsResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.ensembleMetrics = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.queueMetrics = undefined;
    }
}
/**
 * Path parameters for get Ensemble status counts
 */
class GetQueuePendingCountPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Response for getQueuePendingCount
 */
class GetQueuePendingCountResp {
    constructor() {
        /**
         * Number of messages in either ready or wait status. This count indicates the queue depth.
         * Required: false
         * Array: false
         */
        this.pendingCount = undefined;
    }
}
/**
 * Request to Restart execution of a Started or Not Started  Ensemble
 */
class RestartEnsemblePath {
    constructor() {
        /**
         * Name of the queue
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         * Unique identifier for the application workflow.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
    }
}
/**
 * Request to Restart execution of a Started or Not Started  Ensemble
 */
class RestartEnsembleRqst {
}
/**
 * Response to the Request to Restart execution of a Started or Not Started  Ensemble
 */
class RestartEnsembleResp {
    constructor() {
        /**
         * Ensemble that was Restarted.
         * Required: false
         * Array: false
         */
        this.ensembleRestartedInd = undefined;
    }
}
/**
 * Request to Resume execution of a Suspended ensemble
 */
class ResumeEnsemblePath {
    constructor() {
        /**
         * Name of the queue
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         * Unique identifier for the application workflow.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
    }
}
/**
 * Request to Resume execution of a Suspended ensemble
 */
class ResumeEnsembleRqst {
}
/**
 * Response to the Request to Resume execution of a Suspended ensemble
 */
class ResumeEnsembleResp {
    constructor() {
        /**
         * Ensemble that was Resumed
         * Required: false
         * Array: false
         */
        this.ensembleResumedInd = undefined;
    }
}
/**
 * Request to start ensemble.
 */
class StartMessageDrivenEnsembleRqst {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.queue = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.messageId = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.message = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.eventDataType = undefined;
    }
}
/**
 * Enter comments
 */
class StartMessageDrivenEnsembleResp {
    constructor() {
        /**
         * Instance ID of the ensemble that was started.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
    }
}
/**
 * Request to stop execution of an Ensemble
 */
class KillEnsembleRqst {
    constructor() {
        /**
         * Unique identifier for the ensemble.
         * Required: true
         * Array: true
         */
        this.ensembleInstIds = undefined;
    }
}
/**
 * Response to the request to stop execution of an Ensemble
 */
class KillEnsembleResp {
    constructor() {
        /**
         * Ensembles that were killed.
         * Required: false
         * Array: true
         */
        this.status = undefined;
    }
}
/**
 * Path parameters for stopQueue
 */
class StopQueuePath {
    constructor() {
        /**
         * Name of the queue to stop
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Path parameters for stopQueue
 */
class StopQueueWebhookPath {
    constructor() {
        /**
         * Name of the queue to stop
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Path parameters for stopQueue
 */
class StopQueueWebhookQuery {
    constructor() {
        /**
         * Authorization token
         * Required: false
         * Array: false
         */
        this.auth_token = undefined;
    }
}
/**
 * Path parameters for startQueue
 */
class StartQueuePath {
    constructor() {
        /**
         * Name of the queue to start
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Response for listQueues
 */
class ListQueuesResp {
    constructor() {
        /**
         * Name of the queue to start
         * Required: false
         * Array: true
         */
        this.queues = undefined;
    }
}
/**
 * Path parameters
 */
class ListExpiredMessagesPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
        /**
         * From enqueue timestamp
         * Required: true
         * Array: false
         */
        this.enqueueFromTmst = undefined;
        /**
         * Tom enqueue timestamp
         * Required: true
         * Array: false
         */
        this.enqueueToTmst = undefined;
    }
}
/**
 * Response
 */
class ListExpiredMessagesResp {
    constructor() {
        /**
         * Name of the queue
         * Required: false
         * Array: true
         */
        this.message = undefined;
    }
}
/**
 * Path parameters
 */
class DeleteExpiredMessagesPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
    }
}
/**
 * Path parameters
 */
class DeleteExpiredMessagesQuery {
    constructor() {
        /**
         * Id of the message to be deleted
         * Required: true
         * Array: true
         */
        this.messageId = undefined;
    }
}
/**
 * Response to the request to stop execution of an Ensemble
 */
class DeleteExpiredMessagesResp {
    constructor() {
        /**
         * Ensembles that were killed.
         * Required: false
         * Array: true
         */
        this.status = undefined;
    }
}
/**
 * Path parameters
 */
class ReplayMessagePath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.queueName = undefined;
        /**
         * ID of the message to replay. It needs to be in expired status
         * Required: true
         * Array: false
         */
        this.messageId = undefined;
    }
}
/**
 * Path parameters for get Ensemble status counts
 */
class GetPubSubStatusCountsPath {
    constructor() {
        /**
         * Name of the queue
         * Required: true
         * Array: false
         */
        this.subscriptionId = undefined;
        /**
         * From timestamp
         * Required: true
         * Array: false
         */
        this.fromTmst = undefined;
        /**
         * To timestamp
         * Required: true
         * Array: false
         */
        this.toTmst = undefined;
    }
}
/**
 * Response to the request to get Ensemble status counts
 */
class GetPubSubStatusCountsResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.pubsubMetrics = undefined;
    }
}
/**
 * Path parameters for startSubscription
 */
class StartSubscriptionPath {
    constructor() {
        /**
         * Id of the subscription to start
         * Required: false
         * Array: false
         */
        this.subscriptionId = undefined;
    }
}
/**
 * Path parameters for stopSubscription
 */
class StopSubscriptionPath {
    constructor() {
        /**
         * Id of the subscription to stop
         * Required: false
         * Array: false
         */
        this.subscriptionId = undefined;
    }
}
/**
 * Path parameters for get Undelivered Message counts
 */
class GetUndeliveredMessagesPath {
    constructor() {
        /**
         * Id of subscription
         * Required: true
         * Array: false
         */
        this.subscriptionId = undefined;
    }
}
/**
 * Response for getUndeliveredMessages
 */
class GetUndeliveredMessagesResp {
    constructor() {
        /**
         * Number of Undelivered Messages.
         * Required: false
         * Array: false
         */
        this.undeliveredCount = undefined;
    }
}
/**
 * Response for listSubscriptions
 */
class ListSubscriptionsResp {
    constructor() {
        /**
         * Name of the queue to start
         * Required: false
         * Array: true
         */
        this.subscriptions = undefined;
    }
}
/**
 * Path parameters for Get subscription count
 */
class GetSubscriptionPath {
    constructor() {
        /**
         * Subscription id
         * Required: true
         * Array: false
         */
        this.subscriptionId = undefined;
    }
}
/**
 * Returns status of a given subscription
 */
class GetSubscriptionResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.subscription = undefined;
    }
}
/**
 * Path parameters for startChannel
 */
class StartChannelPath {
    constructor() {
        /**
         * Name of the channel to start
         * Required: false
         * Array: false
         */
        this.channelName = undefined;
    }
}
/**
 * Path parameters for stopChannel
 */
class StopChannelPath {
    constructor() {
        /**
         * Name of the channel to stop
         * Required: false
         * Array: false
         */
        this.channelName = undefined;
    }
}
/**
 * Response for listChannels
 */
class ListChannelsResp {
    constructor() {
        /**
         * list of channels
         * Required: false
         * Array: true
         */
        this.channels = undefined;
    }
}
class MessageDrivenEnsemblePayload {
    constructor() {
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventType = undefined;
        /**
         * The event occurrence timestamp
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The event occurrence timestamp in microseconds
         * Required: false
         * Array: false
         */
        this.eventTmstMicro = undefined;
        /**
         * The correlation ID of the originating transaction
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * The event data. Use JSON format with previous and current values of all attributes that were changed by this event
         * Required: false
         * Array: false
         */
        this.eventData = undefined;
    }
}
class DynamicMessageDrivenPayload {
    constructor() {
        /**
         * The type of the payload
         * Required: true
         * Array: false
         */
        this.eventDataType = undefined;
        /**
         * The message payload
         * Required: true
         * Array: false
         */
        this.payload = undefined;
    }
}
class TransactionEventEnsemblePayload {
    constructor() {
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventType = undefined;
        /**
         * The event occurrence timestamp
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The event occurrence timestamp in microseconds
         * Required: false
         * Array: false
         */
        this.eventTmstMicro = undefined;
        /**
         * The correlation ID of the originating transaction
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * The event data. Use JSON format with previous and current values of all attributes that were changed by this event
         * Required: false
         * Array: false
         */
        this.eventData = undefined;
    }
}
/**
 * Status of a delete expired message request
 */
class DeleteExpiredMessageStatus {
    constructor() {
        /**
         * Unique identifier for the ensemble record.
         * Required: false
         * Array: false
         */
        this.messageId = undefined;
        /**
         * Indicates whether the ensemble was killed.
         * Required: false
         * Array: false
         */
        this.messageDeletedInd = undefined;
        /**
         * A status describing why the message could not be deleted. Populated if messageDeletedInd is false
         * Required: false
         * Array: false
         */
        this.failStatus = undefined;
    }
}
/**
 * Status of a kill ensemble request
 */
class KillEnsembleStatus {
    constructor() {
        /**
         * Unique identifier for the ensemble record.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
        /**
         * Indicates whether the ensemble was killed.
         * Required: false
         * Array: false
         */
        this.ensembleKilledInd = undefined;
        /**
         * A status describing why the ensemble could not be killed. Populated if ensembleKilledInd is false
         * Required: false
         * Array: false
         */
        this.failStatus = undefined;
    }
}
/**
 * Stores execution information for application workflows.
 */
class EnsembleStateSearchRecord {
    constructor() {
        /**
         * Unique identifier for the ensemble record.
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState = undefined;
    }
}
class Payload {
    constructor() {
        /**
         * Required: true
         * Array: false
         */
        this.type = undefined;
        /**
         * Required: true
         * Array: false
         */
        this.value = undefined;
    }
}
class EnsembleState {
    constructor() {
        /**
         * Unique identifier for the ensemble record.
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Name of the application workflow.
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * A short description of the ensemble
         * Required: false
         * Array: false
         */
        this.desc = undefined;
        /**
         * Name of the queue publishing this message.
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         * Id of the message.
         * Required: false
         * Array: false
         */
        this.messageId = undefined;
        /**
         * The timestamp of when the trigger event was created.
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The timestamp of when the message was received by ensemble.
         * Required: false
         * Array: false
         */
        this.recvTmst = undefined;
        /**
         * The timestamp of when this ensemble was dispatched to the executor thread.
         * Required: false
         * Array: false
         */
        this.dispatchTmst = undefined;
        /**
         * The timestamp of when this ensemble processing started.
         * Required: false
         * Array: false
         */
        this.strtTmst = undefined;
        /**
         * The timestamp of when this ensemble processing ended.
         * Required: false
         * Array: false
         */
        this.endTmst = undefined;
        /**
         * Dequeue time in milliseconds. Populated for started ensembles, and is the difference between the received and event timestamps.
         * Required: false
         * Array: false
         */
        this.dequeueTime = undefined;
        /**
         * Dispatch time in milliseconds. Populated for started ensembles, and is the difference between the dispatch and received timestamps.
         * Required: false
         * Array: false
         */
        this.dispatchTime = undefined;
        /**
         * Wait time in milliseconds. Populated for started ensembles, and is the difference between the start and dispatch timestamps.
         * Required: false
         * Array: false
         */
        this.waitTime = undefined;
        /**
         * Time in milliseconds it took to process this ensemble from the time it was started. Populated for completed ensembles, and is the difference between the end and start timestamps.
         * Required: false
         * Array: false
         */
        this.processTime = undefined;
        /**
         * Total elapsed time in milliseconds to process this ensemble from the time the event was created. Populated for completed ensembles, and is the difference between the start and event timestamps.
         * Required: false
         * Array: false
         */
        this.totalTime = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.lstUpdtTmst = undefined;
        /**
         * Status of workflow execution.
         *
         * Valid values:
         * NOT_STARTED
         * STARTED
         * SUSPENDED
         * COMPLETED
         * Required: false
         * Array: false
         */
        this.statCd = undefined;
        /**
         * Status message for the workflow execution.  This could be an error message, stacktrace, success message, etc.
         * Required: false
         * Array: false
         */
        this.statMsg = undefined;
        /**
         * Same value for CORRELATION
         *
         * id is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multiple rows across various tables for a single business
         *
         * transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * Name of the host on which the ensemble was last processed
         * Required: false
         * Array: false
         */
        this.host = undefined;
        /**
         * Name of the thread on which the ensemble was last processed
         * Required: false
         * Array: false
         */
        this.thread = undefined;
        /**
         * Timestamp of when the ensemble started waiting for lock
         * Required: false
         * Array: false
         */
        this.lockWaitStartTmst = undefined;
        /**
         * Time spent on waiting for lock
         * Required: false
         * Array: false
         */
        this.elapsedLockWaitTime = undefined;
        /**
         * Number of times this ensemble was put on lock wait
         * Required: false
         * Array: false
         */
        this.lockWaitCount = undefined;
        /**
         * When the ensemble was paused
         * Required: false
         * Array: false
         */
        this.pauseStartTmst = undefined;
        /**
         * When the pause will expire
         * Required: false
         * Array: false
         */
        this.pauseExpiryTime = undefined;
        /**
         * Number of times this ensemble was put on pause
         * Required: false
         * Array: false
         */
        this.pauseCount = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.minuetStates = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.gotoEnsembleStates = undefined;
        /**
         * Payload that is input to the ensemble execution.
         * Required: false
         * Array: false
         */
        this.payload = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.executionContext = undefined;
    }
}
class NestedEnsembleState {
    constructor() {
        /**
         * Name of the application workflow.
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.minuetStates = undefined;
    }
}
class EnsembleExecutionContext {
    constructor() {
        /**
         * Name of the application workflow.
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.minuetPtr = undefined;
    }
}
/**
 * Stores execution information for the tasks that compose the application workflow.
 */
class MinuetState {
    constructor() {
        /**
         * Name of the task.
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Response payload that is output  from the task.
         * Required: false
         * Array: false
         */
        this.respPayload = undefined;
        /**
         * Datetime the task execution started
         * Required: false
         * Array: false
         */
        this.strtTmst = undefined;
        /**
         * Datetime the task execution ended
         * Required: false
         * Array: false
         */
        this.endTmst = undefined;
        /**
         * Time in milliseconds it took to process this minuet from the time it was started. Populated for completed minuets, and is the difference between the end and start timestamps.
         * Required: false
         * Array: false
         */
        this.processTime = undefined;
        /**
         * Number of times this minuet was retried
         * Required: false
         * Array: false
         */
        this.executionCount = undefined;
        /**
         * Status of task execution.
         *
         * Valid values:
         * STARTED
         * FAILED
         * COMPLETED
         * Required: false
         * Array: false
         */
        this.statCd = undefined;
        /**
         * Status message for the task.  This could be an error message, stacktrace, success message, etc.
         * Required: false
         * Array: false
         */
        this.statMsg = undefined;
    }
}
class EnsembleMetrics {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.notStartedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.startedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.completedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.suspendedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.failedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.killedCount = undefined;
    }
}
class PubSubMetrics {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.sentMessageCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ackedMessageCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.expiredAckDeadLinesCount = undefined;
    }
}
class QueueMetrics {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.readyCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.waitCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.processedCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.expiredCount = undefined;
    }
}
class AuxMessagePublishers {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.queueTypeCd = undefined;
    }
}
class EnsembleConfiguration {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.component = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.mode = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.shortName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.sourceTable = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.payloadType = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.cacheEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.lockEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.retriggerEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.waitEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.rulesEngineEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.messagePublisherEnabled = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.auxMessagePublishers = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.fileAccessEnabled = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.synchronousResponseType = undefined;
    }
}
class Subscription {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.id = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.status = undefined;
    }
}
class Channel {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.status = undefined;
    }
}
class LTLEventCarrierManagement {
    constructor() {
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventType = undefined;
        /**
         * Contains a list of additional event types that are included in this event.
         * Required: false
         * Array: true
         */
        this.auxEventTypes = undefined;
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The name of component from which this event originated.
         * Required: false
         * Array: false
         */
        this.srcComponent = undefined;
        /**
         * The correlation ID of the originating transaction
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * A unique id for the event. If this is chunked, the eventId will help in combining chunks of the same message
         * Required: false
         * Array: false
         */
        this.eventId = undefined;
        /**
         * If there are a large number of payloads, the events can be chunked and published as smaller payloads. Set chunkInd to true if this is a chunk of a larger event message
         * Required: false
         * Array: false
         */
        this.chunkedInd = undefined;
        /**
         * If this is a chunked event message, specifies the sequence number of this instance
         * Required: false
         * Array: false
         */
        this.chunkSeqNbr = undefined;
        /**
         * If this is a chunked event message, specifies the total number of chunks
         * Required: false
         * Array: false
         */
        this.totalChunks = undefined;
        /**
         * The event data. Use JSON format with previous and current values of all attributes that were changed by this event
         * Required: false
         * Array: true
         */
        this.eventData = undefined;
    }
}
class LTLEventCmsCartage {
    constructor() {
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventType = undefined;
        /**
         * Contains a list of additional event types that are included in this event.
         * Required: false
         * Array: true
         */
        this.auxEventTypes = undefined;
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The name of component from which this event originated.
         * Required: false
         * Array: false
         */
        this.srcComponent = undefined;
        /**
         * The correlation ID of the originating transaction
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * A unique id for the event. If this is chunked, the eventId will help in combining chunks of the same message
         * Required: false
         * Array: false
         */
        this.eventId = undefined;
        /**
         * If there are a large number of payloads, the events can be chunked and published as smaller payloads. Set chunkInd to true if this is a chunk of a larger event message
         * Required: false
         * Array: false
         */
        this.chunkedInd = undefined;
        /**
         * If this is a chunked event message, specifies the sequence number of this instance
         * Required: false
         * Array: false
         */
        this.chunkSeqNbr = undefined;
        /**
         * If this is a chunked event message, specifies the total number of chunks
         * Required: false
         * Array: false
         */
        this.totalChunks = undefined;
        /**
         * The event data. Use JSON format with previous and current values of all attributes that were changed by this event
         * Required: false
         * Array: true
         */
        this.eventData = undefined;
    }
}
/**
 * The root element for creating messages.
 */
class cboMsgHSSScheduleJMS {
    constructor() {
        /**
         * The header part of the message.
         * Required: false
         * Array: false
         */
        this.CBOHeader = undefined;
        /**
         * The tracking information of the requestor.
         * Required: false
         * Array: false
         */
        this.trackingInfo = undefined;
        /**
         * The event data.
         * Required: false
         * Array: false
         */
        this.CBO = undefined;
    }
}
class LTLEventHSSScheduleJMS {
    constructor() {
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventType = undefined;
        /**
         * Contains a list of additional event types that are included in this event.
         * Required: false
         * Array: true
         */
        this.auxEventTypes = undefined;
        /**
         * The type of event. This will determine which ensemble to execute
         * Required: false
         * Array: false
         */
        this.eventTmst = undefined;
        /**
         * The name of component from which this event originated.
         * Required: false
         * Array: false
         */
        this.srcComponent = undefined;
        /**
         * The correlation ID of the originating transaction
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * A unique id for the event. If this is chunked, the eventId will help in combining chunks of the same message
         * Required: false
         * Array: false
         */
        this.eventId = undefined;
        /**
         * If there are a large number of payloads, the events can be chunked and published as smaller payloads. Set chunkInd to true if this is a chunk of a larger event message
         * Required: false
         * Array: false
         */
        this.chunkedInd = undefined;
        /**
         * If this is a chunked event message, specifies the sequence number of this instance
         * Required: false
         * Array: false
         */
        this.chunkSeqNbr = undefined;
        /**
         * If this is a chunked event message, specifies the total number of chunks
         * Required: false
         * Array: false
         */
        this.totalChunks = undefined;
        /**
         * The event data. Use JSON format with previous and current values of all attributes that were changed by this event
         * Required: false
         * Array: true
         */
        this.eventData = undefined;
    }
}
/**
 * An Update response from a BULK update to elastic
 */
class BulkUpdateResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this._index = undefined;
        /**
         * Required: false
         * Array: false
         */
        this._id = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.result = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.status = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.error = undefined;
    }
}
/**
 * Details of an error for an item
 */
class BulkUpdateItemError {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.type = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.reason = undefined;
    }
}
/**
 * An item in the bulk api response
 */
class BulkApiRespItem {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.update = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.index = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.create = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.delete = undefined;
    }
}
class EsAggregationFieldRqst {
    constructor() {
        /**
         * the name of the property to aggregate on (siteCode, employeeCode, etc.)
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * aggregation type on that property. Options for field object: term, date, daterange, distinctCount. Options for subfield object: term, stats, date, ranges, distinctCount
         * Required: false
         * Array: false
         */
        this.type = undefined;
        /**
         * max number of rows to return
         * Required: false
         * Array: false
         */
        this.size = undefined;
        /**
         * second, minute, hour, day, week, month, quarter, year. Applies only when type is set to date
         * Required: false
         * Array: false
         */
        this.dateInterval = undefined;
        /**
         * min number of documents to filter date interval on. Applies only when type is set to date
         * Required: false
         * Array: false
         */
        this.minimumDocumentCount = undefined;
        /**
         * date range filter
         * Required: false
         * Array: true
         */
        this.ranges = undefined;
        /**
         * min number of documents to filter date interval on. Applies only when type is set to date
         * Required: false
         * Array: true
         */
        this.subFields = undefined;
    }
}
class EsAggregationDateRange {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.from = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.to = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.key = undefined;
    }
}
class EsDynamicPivotRqst {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.fields = undefined;
    }
}
class EsAggregationRqst {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.dynamicPivot = undefined;
    }
}
class EsAggregationFieldResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.key = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.date = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.from = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.fromAsString = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.to = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.toAsString = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.docCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.subFields = undefined;
    }
}
class EsAggregationResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.dynamicPivot = undefined;
    }
}
class EnsembleStateSearchFilterNot {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.and = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.or = undefined;
    }
}
class EnsembleStateSearchFilterOr {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.instId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host_keyword = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.and = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.not = undefined;
        this.toJSON = function () {
            return {
                "instId": this.instId,
                "instId.keyword": this.instId_keyword,
                "ensembleState.messageId": this.ensembleState_messageId,
                "ensembleState.messageId.keyword": this.ensembleState_messageId_keyword,
                "ensembleState.queueName": this.ensembleState_queueName,
                "ensembleState.queueName.keyword": this.ensembleState_queueName_keyword,
                "ensembleState.name": this.ensembleState_name,
                "ensembleState.name.keyword": this.ensembleState_name_keyword,
                "ensembleState.desc": this.ensembleState_desc,
                "ensembleState.desc.keyword": this.ensembleState_desc_keyword,
                "ensembleState.eventTmst": this.ensembleState_eventTmst,
                "ensembleState.eventTmst.keyword": this.ensembleState_eventTmst_keyword,
                "ensembleState.strtTmst": this.ensembleState_strtTmst,
                "ensembleState.strtTmst.keyword": this.ensembleState_strtTmst_keyword,
                "ensembleState.endTmst": this.ensembleState_endTmst,
                "ensembleState.endTmst.keyword": this.ensembleState_endTmst_keyword,
                "ensembleState.statCd": this.ensembleState_statCd,
                "ensembleState.statCd.keyword": this.ensembleState_statCd_keyword,
                "ensembleState.correlationId": this.ensembleState_correlationId,
                "ensembleState.correlationId.keyword": this.ensembleState_correlationId_keyword,
                "ensembleState.businessKey1": this.ensembleState_businessKey1,
                "ensembleState.businessKey1.keyword": this.ensembleState_businessKey1_keyword,
                "ensembleState.businessKey2": this.ensembleState_businessKey2,
                "ensembleState.businessKey2.keyword": this.ensembleState_businessKey2_keyword,
                "ensembleState.businessKey3": this.ensembleState_businessKey3,
                "ensembleState.businessKey3.keyword": this.ensembleState_businessKey3_keyword,
                "ensembleState.businessKey4": this.ensembleState_businessKey4,
                "ensembleState.businessKey4.keyword": this.ensembleState_businessKey4_keyword,
                "ensembleState.businessKey5": this.ensembleState_businessKey5,
                "ensembleState.businessKey5.keyword": this.ensembleState_businessKey5_keyword,
                "ensembleState.host": this.ensembleState_host,
                "ensembleState.host.keyword": this.ensembleState_host_keyword,
                "and": this.and,
                "not": this.not
            };
        };
    }
}
class EnsembleStateSearchFilterAnd {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.instId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host_keyword = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.or = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.not = undefined;
        this.toJSON = function () {
            return {
                "instId": this.instId,
                "instId.keyword": this.instId_keyword,
                "ensembleState.messageId": this.ensembleState_messageId,
                "ensembleState.messageId.keyword": this.ensembleState_messageId_keyword,
                "ensembleState.queueName": this.ensembleState_queueName,
                "ensembleState.queueName.keyword": this.ensembleState_queueName_keyword,
                "ensembleState.name": this.ensembleState_name,
                "ensembleState.name.keyword": this.ensembleState_name_keyword,
                "ensembleState.desc": this.ensembleState_desc,
                "ensembleState.desc.keyword": this.ensembleState_desc_keyword,
                "ensembleState.eventTmst": this.ensembleState_eventTmst,
                "ensembleState.eventTmst.keyword": this.ensembleState_eventTmst_keyword,
                "ensembleState.strtTmst": this.ensembleState_strtTmst,
                "ensembleState.strtTmst.keyword": this.ensembleState_strtTmst_keyword,
                "ensembleState.endTmst": this.ensembleState_endTmst,
                "ensembleState.endTmst.keyword": this.ensembleState_endTmst_keyword,
                "ensembleState.statCd": this.ensembleState_statCd,
                "ensembleState.statCd.keyword": this.ensembleState_statCd_keyword,
                "ensembleState.correlationId": this.ensembleState_correlationId,
                "ensembleState.correlationId.keyword": this.ensembleState_correlationId_keyword,
                "ensembleState.businessKey1": this.ensembleState_businessKey1,
                "ensembleState.businessKey1.keyword": this.ensembleState_businessKey1_keyword,
                "ensembleState.businessKey2": this.ensembleState_businessKey2,
                "ensembleState.businessKey2.keyword": this.ensembleState_businessKey2_keyword,
                "ensembleState.businessKey3": this.ensembleState_businessKey3,
                "ensembleState.businessKey3.keyword": this.ensembleState_businessKey3_keyword,
                "ensembleState.businessKey4": this.ensembleState_businessKey4,
                "ensembleState.businessKey4.keyword": this.ensembleState_businessKey4_keyword,
                "ensembleState.businessKey5": this.ensembleState_businessKey5,
                "ensembleState.businessKey5.keyword": this.ensembleState_businessKey5_keyword,
                "ensembleState.host": this.ensembleState_host,
                "ensembleState.host.keyword": this.ensembleState_host_keyword,
                "or": this.or,
                "not": this.not
            };
        };
    }
}
class EnsembleStateSearchFilter {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.q = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.b = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.instId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_messageId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_queueName_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_name_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_desc_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_eventTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_strtTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_endTmst_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_statCd_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_correlationId_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey1_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey2_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey3_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey4_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5 = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_businessKey5_keyword = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.ensembleState_host_keyword = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.and = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.or = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.not = undefined;
        this.toJSON = function () {
            return {
                "q": this.q,
                "b": this.b,
                "instId": this.instId,
                "instId.keyword": this.instId_keyword,
                "ensembleState.messageId": this.ensembleState_messageId,
                "ensembleState.messageId.keyword": this.ensembleState_messageId_keyword,
                "ensembleState.queueName": this.ensembleState_queueName,
                "ensembleState.queueName.keyword": this.ensembleState_queueName_keyword,
                "ensembleState.name": this.ensembleState_name,
                "ensembleState.name.keyword": this.ensembleState_name_keyword,
                "ensembleState.desc": this.ensembleState_desc,
                "ensembleState.desc.keyword": this.ensembleState_desc_keyword,
                "ensembleState.eventTmst": this.ensembleState_eventTmst,
                "ensembleState.eventTmst.keyword": this.ensembleState_eventTmst_keyword,
                "ensembleState.strtTmst": this.ensembleState_strtTmst,
                "ensembleState.strtTmst.keyword": this.ensembleState_strtTmst_keyword,
                "ensembleState.endTmst": this.ensembleState_endTmst,
                "ensembleState.endTmst.keyword": this.ensembleState_endTmst_keyword,
                "ensembleState.statCd": this.ensembleState_statCd,
                "ensembleState.statCd.keyword": this.ensembleState_statCd_keyword,
                "ensembleState.correlationId": this.ensembleState_correlationId,
                "ensembleState.correlationId.keyword": this.ensembleState_correlationId_keyword,
                "ensembleState.businessKey1": this.ensembleState_businessKey1,
                "ensembleState.businessKey1.keyword": this.ensembleState_businessKey1_keyword,
                "ensembleState.businessKey2": this.ensembleState_businessKey2,
                "ensembleState.businessKey2.keyword": this.ensembleState_businessKey2_keyword,
                "ensembleState.businessKey3": this.ensembleState_businessKey3,
                "ensembleState.businessKey3.keyword": this.ensembleState_businessKey3_keyword,
                "ensembleState.businessKey4": this.ensembleState_businessKey4,
                "ensembleState.businessKey4.keyword": this.ensembleState_businessKey4_keyword,
                "ensembleState.businessKey5": this.ensembleState_businessKey5,
                "ensembleState.businessKey5.keyword": this.ensembleState_businessKey5_keyword,
                "ensembleState.host": this.ensembleState_host,
                "ensembleState.host.keyword": this.ensembleState_host_keyword,
                "and": this.and,
                "or": this.or,
                "not": this.not
            };
        };
    }
}
/**
 * Path parameters
 */
class GetElasticDocumentEnsembleStatePath {
    constructor() {
        /**
         * Uniquely identify the elastic search document
         * Required: true
         * Array: false
         */
        this.instId = undefined;
    }
}
/**
 * Query parameters
 */
class GetElasticDocumentEnsembleStateQuery {
    constructor() {
        /**
         * Source filter
         * Required: false
         * Array: false
         */
        this._source = undefined;
        /**
         * Source include filter
         * Required: false
         * Array: false
         */
        this._source_includes = undefined;
        /**
         * Source exclude filter
         * Required: false
         * Array: false
         */
        this._source_excludes = undefined;
    }
}
/**
 * Response from getElasticDocument.
 */
class GetElasticDocumentEnsembleStateResp {
    constructor() {
        /**
         * The record if found
         * Required: false
         * Array: false
         */
        this.record = undefined;
    }
}
/**
 * Query parameters
 */
class GetElasticDocumentEnsembleStateCountQuery {
    constructor() {
        /**
         * Query filter
         * Required: false
         * Array: false
         */
        this.q = undefined;
    }
}
/**
 * Response from getElasticDocumentCount.
 */
class GetElasticDocumentEnsembleStateCountResp {
    constructor() {
        /**
         * The count of the documents
         * Required: false
         * Array: false
         */
        this.count = undefined;
    }
}
/**
 * Request message to update information for EnsembleState.
 */
class UpdateElasticDocumentEnsembleStateRqst {
    constructor() {
        /**
         * The record to upsert in elastic
         * Required: false
         * Array: false
         */
        this.doc = undefined;
        /**
         * Indicate if an upsert operation should be executed if the document was not found
         * Required: false
         * Array: false
         */
        this.doc_as_upsert = undefined;
    }
}
/**
 * Path parameters
 */
class UpdateElasticDocumentEnsembleStatePath {
    constructor() {
        /**
         * Uniquely identify the elastic search document
         * Required: true
         * Array: false
         */
        this.instId = undefined;
    }
}
/**
 * Response from updateElasticDocument.
 */
class UpdateElasticDocumentEnsembleStateResp {
    constructor() {
        /**
         * The result of the operation
         * Required: false
         * Array: false
         */
        this.result = undefined;
    }
}
/**
 * Response from bulkUpdateElasticDocument.
 */
class BulkUpdateElasticDocumentEnsembleStateResp {
    constructor() {
        /**
         * The time it took to process this request
         * Required: false
         * Array: false
         */
        this.took = undefined;
        /**
         * Indicates if there are any errors
         * Required: false
         * Array: false
         */
        this.errors = undefined;
        /**
         * Results of the bulk operations
         * Required: false
         * Array: true
         */
        this.items = undefined;
    }
}
/**
 * Path parameters
 */
class DeleteElasticDocumentEnsembleStatePath {
    constructor() {
        /**
         * Uniquely identify the elastic search document
         * Required: true
         * Array: false
         */
        this.instId = undefined;
    }
}
/**
 * Request message to delete information for EnsembleState.
 */
class DeleteElasticDocumentEnsembleStateResp {
    constructor() {
        /**
         * The result of the operation
         * Required: false
         * Array: false
         */
        this.result = undefined;
    }
}
/**
 * Request message to search information for ensemble-state-unfiltered.
 */
class SearchEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.pageNumber = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.sortExpressions = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pageSize = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.fields = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.excludeFields = undefined;
        /**
         * Query for searching
         * Required: false
         * Array: false
         */
        this.filter = undefined;
    }
}
/**
 * Response to the request to search information for ensemble-state-unfiltered.
 */
class SearchEnsembleStateUnfilteredResp {
    constructor() {
        /**
         * Required: false
         * Array: false
         */
        this.header = undefined;
        /**
         * Search results
         * Required: false
         * Array: true
         */
        this.result = undefined;
    }
}
/**
 * Request message to export information for ensemble-state-unfiltered.
 */
class ExportEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Required: false
         * Array: true
         */
        this.fields = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.fileType = undefined;
        /**
         * Query for exporting
         * Required: false
         * Array: false
         */
        this.filter = undefined;
    }
}
/**
 * Request for register filter
 */
class RegisterFilterEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Id of the  user
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Connection token
         * Required: false
         * Array: false
         */
        this.connectionToken = undefined;
        /**
         * The filter to register
         * Required: false
         * Array: false
         */
        this.filter = undefined;
    }
}
/**
 * Response for register filter
 */
class RegisterFilterEnsembleStateUnfilteredResp {
    constructor() {
        /**
         * Hash for the filter
         * Required: false
         * Array: false
         */
        this.filterHash = undefined;
        /**
         * Duration for the API execution
         * Required: false
         * Array: false
         */
        this.duration = undefined;
        /**
         * Number of registrations created
         * Required: false
         * Array: false
         */
        this.numberOfRegistrations = undefined;
    }
}
/**
 * Request for register
 */
class UnregisterFilterEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Id of the  user. For future use.
         * Required: false
         * Array: false
         */
        this.userId = undefined;
        /**
         * Connection token
         * Required: false
         * Array: false
         */
        this.connectionToken = undefined;
        /**
         * The hash of the filter to unregister. Filter has is returned by registerFilter
         * Required: false
         * Array: false
         */
        this.filterHash = undefined;
    }
}
/**
 * Request for changes feed
 */
class ChangesFeedEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * A list of document Ids
         * Required: false
         * Array: true
         */
        this.changedDocumentIds = undefined;
        /**
         * A list of changed documents
         * Required: false
         * Array: true
         */
        this.changedDocuments = undefined;
    }
}
/**
 *
 * 				Request for list aggregations
 * 				To aggregate data by any field you need to specify field properties on top level and subfield properties on any deeper level of aggregation.
 *
 */
class ListAggregationsEnsembleStateUnfilteredRqst {
    constructor() {
        /**
         * Filter for aggregations
         * Required: false
         * Array: false
         */
        this.filter = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pageSize = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.aggregations = undefined;
    }
}
/**
 * Response for list aggregations
 */
class ListAggregationsEnsembleStateUnfilteredResp {
    constructor() {
        /**
         * Aggregations
         * Required: false
         * Array: false
         */
        this.aggregations = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.resultCount = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pageNumber = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pageSize = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.duration = undefined;
    }
}
/**
 * Defines one physical location belonging to a partner carrier.  Added 07/14/2021  LISG-13457
 */
class CarrierLocation {
    constructor() {
        /**
         * Unique identifier
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * System-generated unique ID for this location
         * Required: false
         * Array: false
         */
        this.locationId = undefined;
        /**
         * Type of location
         *
         * Valid Values:
         * CORPORATE
         * TERMINAL
         * Required: false
         * Array: false
         */
        this.locationTypeCd = undefined;
        /**
         * Address of the physical location
         * Required: false
         * Array: false
         */
        this.address = undefined;
        /**
         * Name of city where physical location is located.
         * Required: false
         * Array: false
         */
        this.city = undefined;
        /**
         * State or other territory
         * Required: false
         * Array: false
         */
        this.stateCd = undefined;
        /**
         * Zip code or other postal area code
         * Required: false
         * Array: false
         */
        this.postalCd = undefined;
        /**
         * Two character abbreviation of country
         * Required: false
         * Array: false
         */
        this.countryCd = undefined;
        /**
         * Latitude of the physical location.  Added scale 10 10/12/2021  LISG-15286
         * Required: false
         * Array: false
         */
        this.latitudeNbr = undefined;
        /**
         * Longitude of the physical location.   Added scale 10 10/12/2021  LISG-15286
         * Required: false
         * Array: false
         */
        this.longitudeNbr = undefined;
        /**
         * Same value for CORRELATION id
         *
         * is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multipple rows across various tables for a
         *
         * single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * ?CMS Terminal locations must also have a CIS record for use in the Pickup Request system. This is the key to that CIS record, and it could be a Future Cust.  Added 02/01/2022  LISG-16016
         * Required: false
         * Array: false
         */
        this.cisCustomerNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.carrierLocationSic = undefined;
    }
}
/**
 * Associates a service center with the carrier location the they do business with.  Added 07/14/2021  LISG-13457
 */
class CarrierLocationSic {
    constructor() {
        /**
         * Unique identifier
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * System-generated unique ID for this location
         * Required: false
         * Array: false
         */
        this.locationId = undefined;
        /**
         * Standard identification code of a service center that can use this carrier location
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * XPO email address carrier can use for communicating integration issues that are not fully automated
         * Required: false
         * Array: false
         */
        this.cartageOperationsEmail = undefined;
        /**
         * Same value for CORRELATION id
         *
         * is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multipple rows across various tables for a
         *
         * single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Master list of partner carriers.  Added 04/01/2021 LISG-11106
 */
class CarrierMaster {
    constructor() {
        /**
         * Unique identifier
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * Standard Carrier Alpha Code is a unique two-to-four-letter code useed to identify transporation companies.  They are maintained by the National Motor Freight Traffic Association (NMFTA)
         * Required: false
         * Array: false
         */
        this.scacCd = undefined;
        /**
         * Name of carrier
         * Required: false
         * Array: false
         */
        this.carrierName = undefined;
        /**
         * Same value for CORRELATION id
         *
         * is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multipple rows across various tables for a
         *
         * single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Charge need to apply fuel surcharge for the pulls
 */
class FuelSurcharge {
    constructor() {
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.fuelSurchargeId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.releaseDate = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.effectiveDate = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.expireDate = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.fuelCost = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.fuelSurcharge = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.region5FuelCost = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.region5FuelVariance = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class HssSchedule {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.pullId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.originSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.destinationSicCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scacCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.scheduledDepartureDate = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.bookingNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.loadingOperation = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.trailerNbr = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.cancelInd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.equipmentEventId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Table to stage more invoice details sent to us by carrier partners.  Added 05/03/2021  LISG-11776
 */
class InvoiceItemStaging {
    constructor() {
        /**
         * Unique identifier
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * Unique system-generated id
         * Required: false
         * Array: false
         */
        this.invoiceStagingId = undefined;
        /**
         * Sequence number to uniquely identify the line item within the invoice
         * Required: false
         * Array: false
         */
        this.sequenceNbr = undefined;
        /**
         * Internal identifier of the route this line item is for (in SCO_ROUTE)
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * Internal identifier of the shipment this line item is for
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * Date and time the service described by this line item was performed
         * Required: false
         * Array: false
         */
        this.occurredDateTime = undefined;
        /**
         * Describes the charge type as MAIN or ACCESSORIAL
         * Required: false
         * Array: false
         */
        this.chargeTypeCd = undefined;
        /**
         * Accessorial description
         * Required: false
         * Array: false
         */
        this.accessorialCd = undefined;
        /**
         * Number of units described by this line item
         * Required: false
         * Array: false
         */
        this.unitCount = undefined;
        /**
         * Unit of measure of the units such as EACH, MINUTE, CWT
         * Required: false
         * Array: false
         */
        this.unitUnitOfMeasure = undefined;
        /**
         * Amount charged per unit
         * Required: false
         * Array: false
         */
        this.unitChargeAmount = undefined;
        /**
         * Total amount charged
         * Required: false
         * Array: false
         */
        this.totalChargeAmount = undefined;
        /**
         * Currency code of the charge.
         *
         * Valid Values:
         * USD
         * CDN
         * Required: false
         * Array: false
         */
        this.chargeCurrencyCd = undefined;
        /**
         * Free form text describing the line item
         * Required: false
         * Array: false
         */
        this.remark = undefined;
        /**
         * Business key provided by the carrier
         * Required: false
         * Array: false
         */
        this.routeName = undefined;
        /**
         * Business key provided by the carrier
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * Same value for CORRELATION id
         *
         * is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multipple rows across various tables for a
         *
         * single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Internal identifier of the trip this line item is for.  Added 09/02/2021  LISG-14872
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         * Internal identifier of the pickup request this line item is for.  Added 09/02/2021  LISG-14872
         * Required: false
         * Array: false
         */
        this.pkrPickupRequestId = undefined;
        /**
         * Internal identifier of the pickup shipment this line item is for.  Added 09/02/2021  LISG-14872
         * Required: false
         * Array: false
         */
        this.pkrShipmentId = undefined;
        /**
         * Business key of the pickup request.  Added 09/02/2021  LISG-14872
         * Required: false
         * Array: false
         */
        this.callNbr = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Table to stage invoice data sent to us by carrier partners.  Added 05/03/2021  LISG-11776
 */
class InvoiceStaging {
    constructor() {
        /**
         * Unique identifier
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * Unique system-generated id
         * Required: false
         * Array: false
         */
        this.invoiceStagingId = undefined;
        /**
         * Invoice identifier used by the carrier.
         * Required: false
         * Array: false
         */
        this.carrierInvoiceId = undefined;
        /**
         * Invoice Date
         * Required: false
         * Array: false
         */
        this.invoiceDate = undefined;
        /**
         * Processing status of this record.
         *
         * Valid Values:
         * SUCCESS - status was successfully translated into an internal stop or shipment status
         * FAIL - the status was translated to an internal shipment status, but the update failed
         * UNSUPPORTED - the status provided by the carrier does not currently have an internal equivalent
         * Required: false
         * Array: false
         */
        this.processStatusCd = undefined;
        /**
         * A place to store the error information from a failed update
         * Required: false
         * Array: false
         */
        this.processStatusMessage = undefined;
        /**
         * Same value for CORRELATION id
         *
         * is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multipple rows across various tables for a
         *
         * single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Maintain the miles between two location
 */
class Lane {
    constructor() {
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.laneId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.originSic = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.destSic = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.service = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.miles = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.miles160 = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.milesPerHour = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.driveHours = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.timeChange = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.clockHours = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.timeChangeDst = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.clockHoursDst = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.laneType = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Maintain all the pull related information
 */
class Pull {
    constructor() {
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.pullId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.laneId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.pullTypeId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.companyBusiness = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.scac = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.totalMiles = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.rate = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.applyFuelSurcharge = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.fuelSurcharge = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.booking = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.weight = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.cube = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.bills = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.trailer = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.loadRelease = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.weight2 = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.cube2 = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.bill2 = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.trailer2 = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.loadRelease2 = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.deferredFreight = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.scheduledDepart = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.actualDepart = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.scheduledArrival = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.actualArrival = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.serviceExcept = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.enteredBy = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.dateEntered = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.statusId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.submittedForPayment = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.dedicatedLane = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.loadHidden = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.adhocLoad = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.placardable = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.tripTypeId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.routeTypeId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.rateId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.unloadingOperation = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.loadingOperation = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.specialHandling = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.tankerEndorsed = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.carrierCheckin = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.bucketTypeId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.reason = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.serviceType = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.trailerCarrierToLoad = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Maintain pull comments
 */
class PullComment {
    constructor() {
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.pullId = undefined;
        /**
         * Loaded From CSV File For SQL Server
         * Required: false
         * Array: false
         */
        this.comments = undefined;
    }
}
/**
 * Record of tenders made to a partner carrier. Tenders can be made for a trip or (in future) for a planning route. Every tender will also have to identify the individual shipments or pickup requests as well.   Added 06/24/2021  LISG-13075
 */
class Tender {
    constructor() {
        /**
         * Identifier for the carrier tendered to
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * Part of Primary key: system generated
         * Required: false
         * Array: false
         */
        this.tenderId = undefined;
        /**
         * If a city trip was tendered, this is the id of that trip
         * Required: false
         * Array: false
         */
        this.tripId = undefined;
        /**
         * If a planning route was tendered, this the id of that route
         * Required: false
         * Array: false
         */
        this.routeId = undefined;
        /**
         * Status of the tender:
         *
         * Valid Values:
         * TENDERED
         * ACKOWLEDGED
         * ACCEPTED
         * ACCEPTED_WITH_EXCP
         * REJECTED
         * WITHDRAWN
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         * Same value for CORRELATION id
         *
         * is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multiple rows across various tables for a
         *
         * single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * The list of messages which each describe a failure or rejection in the tender process.  They are formatted for display in a user interface.
         * Required: false
         * Array: true
         */
        this.tenderMessages = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.tenderDetail = undefined;
    }
}
/**
 * Record of the individual shipments that are part of a tender.   Added 06/24/2021  LISG-13075
 */
class TenderDetail {
    constructor() {
        /**
         * Identifier for the carrier tendered to
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * Part of Primary key: system generated
         * Required: false
         * Array: false
         */
        this.tenderId = undefined;
        /**
         * Makes this tender detail unique
         * Required: false
         * Array: false
         */
        this.tenderDetailSequenceNbr = undefined;
        /**
         * If an individual shipment was tendered for delivery, this is the shipment id
         * Required: false
         * Array: false
         */
        this.shipmentInstId = undefined;
        /**
         * PRO number/business key of the shipment tendered for delivery
         * Required: false
         * Array: false
         */
        this.proNbr = undefined;
        /**
         * If an individual pickup request was tendered, this the id of that request
         * Required: false
         * Array: false
         */
        this.pkrPickupRequestId = undefined;
        /**
         * If an individual pickup request was tendered, this identifies the individual shipment on the request
         * Required: false
         * Array: false
         */
        this.pkrShipmentId = undefined;
        /**
         * Call number/business key of the tendered pickup request
         * Required: false
         * Array: false
         */
        this.callNbr = undefined;
        /**
         * Status of the tender detail:
         *
         * Valid Values:
         * TENDERED
         * ACKOWLEDGED
         * ACCEPTED
         * REJECTED
         * WITHDRAWN
         * Required: false
         * Array: false
         */
        this.statusCd = undefined;
        /**
         * Same value for CORRELATION id
         *
         * is assigned to various rows from different tables that form a single business
         *
         * transactions.
         * In other words, this groups multiple rows across various tables for a
         *
         * single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Provides detailed information about why a shipment tender failed (in XPO systems) or was rejected (by partner carrier).  Added 07/13/2021  LISG-13654
         * Required: false
         * Array: false
         */
        this.statusMessage = undefined;
        /**
         * Identifies the trip the tendered shipment was put on when routed by the partner carrier.  Added 07/22/2021  LISG-13654
         * Required: false
         * Array: false
         */
        this.tripInstId = undefined;
        /**
         * Identifies the route the tendered delivery shipment was put on when routed by the partner carrier.  Added 07/22/2021  LISG-13654
         * Required: false
         * Array: false
         */
        this.routeInstId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Holds a snapshot of TenderDetail. Contains the details at the time on an event. It also provides the previous values if an update occured
 * Record of the individual shipments that are part of a tender.   Added 06/24/2021  LISG-13075
 */
class TenderDetailSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         * Identifier for the carrier tendered to
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * Part of Primary key: system generated
         * Required: false
         * Array: false
         */
        this.tenderId = undefined;
        /**
         * Makes this tender detail unique
         * Required: false
         * Array: false
         */
        this.tenderDetailSequenceNbr = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 * Holds a snapshot of Tender. Contains the details at the time on an event. It also provides the previous values if an update occured
 * Record of tenders made to a partner carrier. Tenders can be made for a trip or (in future) for a planning route. Every tender will also have to identify the individual shipments or pickup requests as well.   Added 06/24/2021  LISG-13075
 */
class TenderSnapshot {
    constructor() {
        /**
         * The action that created this snapshot. Add, Update or Delete
         * Required: false
         * Array: false
         */
        this.eventActionCd = undefined;
        /**
         * Identifier for the carrier tendered to
         * Required: false
         * Array: false
         */
        this.carrierId = undefined;
        /**
         * Part of Primary key: system generated
         * Required: false
         * Array: false
         */
        this.tenderId = undefined;
        /**
         * The previous snapshot, before this record was updated.
         * Required: false
         * Array: false
         */
        this.before = undefined;
        /**
         * The current snapshot.
         * Required: false
         * Array: false
         */
        this.after = undefined;
    }
}
/**
 *
 */
class EventWait {
    constructor() {
        /**
         * Unique identifier of records in this table. Values populated from sequence
         * Required: false
         * Array: false
         */
        this.waitInstanceId = undefined;
        /**
         * Id of the ensemble that is being put on lock wait
         * Required: false
         * Array: false
         */
        this.ensembleInstanceId = undefined;
        /**
         * Name of the queue that was the source of this ensemble message
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         * The timestamp of when this ensemble was first put on lock wait
         * Required: false
         * Array: false
         */
        this.waitStartTmst = undefined;
        /**
         * The number of times this ensemble was put on lock wait
         * Required: false
         * Array: false
         */
        this.waitCount = undefined;
        /**
         * The duration of wait in milliseconds
         * Required: false
         * Array: false
         */
        this.waitTime = undefined;
        /**
         * The maximum wait time in milliseconds before the lock will be overridden
         * Required: false
         * Array: false
         */
        this.maxWaitTime = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 *
 */
class RetriggerEvent {
    constructor() {
        /**
         *
         * Required: false
         * Array: false
         */
        this.eventRetriggerId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.regionCd = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.sourceTableName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.queueName = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.transactionId = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         *
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Details of a symphony message
 */
class SymphonyMessage {
    constructor() {
        /**
         * ID of the message
         * Required: false
         * Array: false
         */
        this.messageId = undefined;
        /**
         * Timestamp of when the message was enqueued
         * Required: false
         * Array: false
         */
        this.enqueueTmst = undefined;
        /**
         * Number of time the message was retried
         * Required: false
         * Array: false
         */
        this.retryCount = undefined;
        /**
         * Message payload
         * Required: false
         * Array: false
         */
        this.payload = undefined;
    }
}
/**
 * Details about a message queue. E.g. Oracle Advanced Queue
 */
class SymphonyQueue {
    constructor() {
        /**
         * Name of the queue
         * Required: false
         * Array: false
         */
        this.name = undefined;
        /**
         * Maximum number of retries
         * Required: false
         * Array: false
         */
        this.maxRetries = undefined;
        /**
         * Delay for retries
         * Required: false
         * Array: false
         */
        this.retryDelay = undefined;
        /**
         * Indicates if enqueue is enabled
         * Required: false
         * Array: false
         */
        this.enqueueEnabled = undefined;
        /**
         * Indicates if dequeue is enabled
         * Required: false
         * Array: false
         */
        this.dequeueEnabled = undefined;
        /**
         * The retention time
         * Required: false
         * Array: false
         */
        this.retention = undefined;
    }
}
/**
 * Captures transaction events. API writes one record per transaction.  Added to EVT seed model  06/26/2020
 */
class TransactionEvent {
    constructor() {
        /**
         * PK. Unique ID of the transaction. For Oracle, use the transaction id available in the context. Populated by trigger.
         * Required: false
         * Array: false
         */
        this.transactionId = undefined;
        /**
         * Identifies the type of transaction. Could be method name
         * Required: false
         * Array: false
         */
        this.transactionType = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transactions.
         * In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * Number of seconds to hold event before publishing.  Added 09/21/2020  LISG-7498
         * Required: false
         * Array: false
         */
        this.eventReleaseDelaySeconds = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.transactionDetails = undefined;
        /**
         *
         * Required: false
         * Array: true
         */
        this.transactionBusinessEvents = undefined;
    }
}
/**
 *
 */
class TransactionEventBusiness {
    constructor() {
        /**
         * PK. Unique identifier for the record.  This will be populate by a trigger before insert to get the ID from EVT_TRANSACTION_BUS_SEQ
         * Required: false
         * Array: false
         */
        this.instId = undefined;
        /**
         * The transaction id from the session.  This will be populate by a trigger before insert.
         * Required: false
         * Array: false
         */
        this.transactionId = undefined;
        /**
         * Short description of the business transaction type.
         * Required: false
         * Array: false
         */
        this.transactionType = undefined;
        /**
         * Code identifying the type of business event.
         * Required: false
         * Array: false
         */
        this.typeCd = undefined;
        /**
         * Code identifying the type of business event.
         * Required: false
         * Array: false
         */
        this.subTypeCd = undefined;
        /**
         * Same value for CORRELATION id is assigned to various rows from different tables that form a single business transactions. In other words, this groups multiple rows across various tables for a single business transaction.
         * Required: false
         * Array: false
         */
        this.correlationId = undefined;
        /**
         * Indicates whether to add, update or delete this entry. This will be used for merging lists.
         *
         * A - Add entry to list
         * D - Delete entry from list
         * U - Update entry
         * Required: false
         * Array: false
         */
        this.listActionCd = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
    }
}
/**
 * Stores the snapshot of all the tables that were updated as part of the transaction. The snapshot is a json representation of all columns that were changed. The snapshot will be created by insert/update/delete triggers on the source table.   Added to EVT seed model  06/26/2020
 */
class TransactionEventDetail {
    constructor() {
        /**
         * PK. Unique id for the snapshot record. Generated by Sequence.
         * Required: false
         * Array: false
         */
        this.detailId = undefined;
        /**
         * Unique ID of the transaction. For Oracle, use the transaction id available in the context. Populated by trigger.
         * Required: false
         * Array: false
         */
        this.transactionId = undefined;
        /**
         * Name of the table for which the snapshot is stored
         * Required: false
         * Array: false
         */
        this.tableName = undefined;
        /**
         * Json string containing the before and after values for all the columns that were changed by the transaction.
         * Required: false
         * Array: false
         */
        this.snapshot = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * trip_inst_id, route_inst_id, shp_inst_id etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * Audit information such as create and/or update transaction details - who, when and which program/transaction
         * Required: false
         * Array: false
         */
        this.auditInfo = undefined;
        /**
         * Identifies the type of transaction. Could be method name
         * Required: false
         * Array: false
         */
        this.transactionType = undefined;
    }
}
/**
 * Enter comments
 */
class ListEnsembleConfigurationsResp {
    constructor() {
        /**
         * List of message queues - AQ and JMS
         * Required: false
         * Array: true
         */
        this.queues = undefined;
        /**
         * List of subscribers - Pub/Sub
         * Required: false
         * Array: true
         */
        this.subscriptions = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.apiChannels = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.timers = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.emails = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.files = undefined;
        /**
         * List of API channels
         * Required: false
         * Array: true
         */
        this.jmsQueues = undefined;
    }
}
class TimerConfig {
    constructor() {
        /**
         * Name of the timer.
         * Required: true
         * Array: false
         */
        this.name = undefined;
        /**
         * Interval for timer. Specify in seconds. The value is set in Octopus using the property sym.timer.<name>.intervalInSeconds
         * Required: true
         * Array: false
         */
        this.intervalInSeconds = undefined;
        /**
         * Specify the timer behavior. If fixedRate is set to true, the timer will fire an ensemble once every interval regardless of whether previous tasks are executing.
         * 						If fixedRate is set to false, the timer will be scheduled to fire after the specified interval, once the current execution is complete.
         * 						For both settings, it does not matter whether the ensemble execution is successful or not for the next timer event to be fired.
         * Required: true
         * Array: false
         */
        this.fixedRate = undefined;
        /**
         * An expression similar to crontab. Expression = 'minute hour dayOfMonth month dayOfWeek'.
         * 						Minute = 0-59, hour = 0-23, dayOfMonth = 1-31, month = [1-12 or JAN, FEB, ..., DEC],  dayOfWeek = [0-6 OR SUN-SAT].
         * 						[*] = any values, [,] = list of values, [-] = range of values, [/] = step values
         * Required: true
         * Array: false
         */
        this.expression = undefined;
    }
}
class Timer {
    constructor() {
        /**
         * Configuration of the timer.
         * Required: true
         * Array: false
         */
        this.configuration = undefined;
        /**
         * Indicates whether the timer is running. True indicates timer is running
         * Required: true
         * Array: false
         */
        this.runningInd = undefined;
    }
}
/**
 * Path parameters for listTimerEnsembles
 */
class ListTimerEnsemblesPath {
    constructor() {
        /**
         * The name of the timer ensemble from which the list of timers is requested
         * Required: false
         * Array: false
         */
        this.name = undefined;
    }
}
/**
 * Response for listTimerEnsembles
 */
class ListTimerEnsemblesResp {
    constructor() {
        /**
         * List of timers defined in this ensemble.
         * Required: false
         * Array: true
         */
        this.timers = undefined;
    }
}
/**
 * Path parameters for startTimerEnsemble
 */
class StartTimerEnsemblePath {
    constructor() {
        /**
         * The name of the timer to start
         * Required: false
         * Array: false
         */
        this.name = undefined;
    }
}
/**
 * Response for startTimerEnsemble
 */
class StartTimerEnsembleResp {
    constructor() {
        /**
         * Indicates whether the timer is running. True indicates timer is running
         * Required: false
         * Array: false
         */
        this.runningInd = undefined;
    }
}
/**
 * Path parameters for stopTimerEnsemble
 */
class StopTimerEnsemblePath {
    constructor() {
        /**
         * The name of the timer to stop
         * Required: false
         * Array: false
         */
        this.name = undefined;
    }
}
/**
 * Response for stopTimerEnsemble
 */
class StopTimerEnsembleResp {
    constructor() {
        /**
         * Indicates whether the timer is running. True indicates timer is running
         * Required: false
         * Array: false
         */
        this.runningInd = undefined;
    }
}
/**
 * Request for startTenderChEnsemble
 */
class StartTenderChEnsembleRqst {
    constructor() {
        /**
         * The name of the ensemble to start
         * Required: false
         * Array: false
         */
        this.ensembleName = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey1 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey2 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey3 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey4 = undefined;
        /**
         * Application key value like
         *
         * pro, shipid, pickupdate etc.
         * Required: false
         * Array: false
         */
        this.businessKey5 = undefined;
        /**
         * The payload for the ensemble process
         * Required: false
         * Array: false
         */
        this.payload = undefined;
    }
}
/**
 * Path parameters for startTenderChEnsemble
 */
class StartTenderChEnsemblePath {
    constructor() {
        /**
         * The name of the channel in which this ensemble will be executed
         * Required: false
         * Array: false
         */
        this.channelName = undefined;
    }
}
/**
 * Query parameters for startTenderChEnsemble
 */
class StartTenderChEnsembleQuery {
    constructor() {
        /**
         * Send true if a synchronous response is required. Normally, channel execute asynchronously.
         * Required: false
         * Array: false
         */
        this.synchronous = undefined;
    }
}
/**
 * Response for startTenderChEnsemble
 */
class StartTenderChEnsembleResp {
    constructor() {
        /**
         * Instance ID of the ensemble that was started.
         * Required: false
         * Array: false
         */
        this.ensembleInstId = undefined;
    }
}
/**
 * Payload for processing carrier tender for a shipment.
 */
class CmsCartageEventPayload extends PayloadType {
    constructor() {
        super(...arguments);
        /**
         * Required: false
         * Array: false
         */
        this.emailAddress = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.sicCd = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.sicName = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.locAddress = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.tender = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.deliveryDocument = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupRequest = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.pickupShipment = undefined;
        /**
         * Required: false
         * Array: false
         */
        this.carrierInvoice = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.carrierInvoiceLineItem = undefined;
        /**
         * Required: false
         * Array: true
         */
        this.shipmentExternalStatuses = undefined;
    }
}
/**
 * Payload for processing carrier management transaction events.
 */
class CarrierManagementEventPayload extends PayloadType {
    constructor() {
        super(...arguments);
        /**
         * Snapshots of the records modified by the transaction event for which this payload was published.
         * Required: false
         * Array: true
         */
        this.snapshots = undefined;
        /**
         * Associated carrier management tenders and nested tender detail records at the time when the event was published.
         * Required: false
         * Array: true
         */
        this.tenders = undefined;
        /**
         * The associated information for the HSS Schedules from the Carrier Management System.
         * Required: false
         * Array: true
         */
        this.hssSchedules = undefined;
    }
}
/**
 * The payload that is used for processing CMS pull events.
 */
class HSSScheduleJMSPayload extends CBOType {
    constructor() {
        super(...arguments);
        /**
         * The information about the ConwayCMSEvents Pulls.
         * Required: false
         * Array: false
         */
        this.CMSPullType = undefined;
    }
}
/**
 * This type will be used to publish documents targeted for Elastic Search on a Kafka topic. The type includes KafkaMessageHeader.
 */
class EnsembleStateSearchRecordMessage extends EnsembleStateSearchRecord {
    constructor() {
        super(...arguments);
        /**
         * Additional details about the document
         * Required: false
         * Array: false
         */
        this.messageHeader = undefined;
    }
}

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

/**
 * @fileoverview added by tsickle
 * @suppress {checkTypes} checked by tsc
 */

export { SdkCarrierManagementModule, CarrierManagementApiService, CreateCarrierInvoicePath, CreateCarrierInvoiceRqst, CreateCarrierTenderRqst, CreateCarrierTenderResp, CreateFuelSurchargeRqst, GetCarrierDetailsQuery, GetCarrierDetailsResp, GetCarrierLocationPath, GetCarrierLocationResp, GetCarrierLocationByCustomerNbrPath, GetCarrierLocationByCustomerNbrResp, GetCarrierTenderPath, GetCarrierTenderResp, GetFuelSurchargeResp, GetSubserviceRatePath, GetSubserviceRateQuery, GetSubserviceRateResp, ListCarriersQuery, ListCarriersResp, ListCarrierTendersRqst, ListCarrierTendersResp, ListTrailerPullsQuery, ListTrailerPullsResp, MaintainCarriersAndLocationsRqst, MaintainCarriersAndLocationsResp, UpdateCarrierTenderPath, UpdateCarrierTenderRqst, UpdateCarrierTenderResp, UpdatePullCommentRqst, UpdateTrailerPullsRqst, UpdateTrailerPullsResp, CarrierInvoice, CarrierInvoiceLineItem, CarrierMasterLocation, ShipmentExternalStatus, CarrierManagementEventSnapshot, CreateTenderPayload, TenderNotification, CBOCmsPullType, TenderNotificationFilter, TenderNotificationChangeRecord, RegisterFilterTenderNotificationsRqst, RegisterFilterTenderNotificationsResp, UnregisterFilterTenderNotificationsRqst, ChangesFeedTenderNotificationsRqst, GetEnsembleStatusCountsPath, GetEnsembleStatusCountsResp, GetQueuePendingCountPath, GetQueuePendingCountResp, RestartEnsemblePath, RestartEnsembleRqst, RestartEnsembleResp, ResumeEnsemblePath, ResumeEnsembleRqst, ResumeEnsembleResp, StartMessageDrivenEnsembleRqst, StartMessageDrivenEnsembleResp, KillEnsembleRqst, KillEnsembleResp, StopQueuePath, StopQueueWebhookPath, StopQueueWebhookQuery, StartQueuePath, ListQueuesResp, ListExpiredMessagesPath, ListExpiredMessagesResp, DeleteExpiredMessagesPath, DeleteExpiredMessagesQuery, DeleteExpiredMessagesResp, ReplayMessagePath, GetPubSubStatusCountsPath, GetPubSubStatusCountsResp, StartSubscriptionPath, StopSubscriptionPath, GetUndeliveredMessagesPath, GetUndeliveredMessagesResp, ListSubscriptionsResp, GetSubscriptionPath, GetSubscriptionResp, StartChannelPath, StopChannelPath, ListChannelsResp, MessageDrivenEnsemblePayload, DynamicMessageDrivenPayload, TransactionEventEnsemblePayload, DeleteExpiredMessageStatus, KillEnsembleStatus, EnsembleStateSearchRecord, Payload, EnsembleState, NestedEnsembleState, EnsembleExecutionContext, MinuetState, EnsembleMetrics, PubSubMetrics, QueueMetrics, AuxMessagePublishers, EnsembleConfiguration, Subscription, Channel, LTLEventCarrierManagement, LTLEventCmsCartage, cboMsgHSSScheduleJMS, LTLEventHSSScheduleJMS, BulkUpdateResp, BulkUpdateItemError, BulkApiRespItem, EsAggregationFieldRqst, EsAggregationDateRange, EsDynamicPivotRqst, EsAggregationRqst, EsAggregationFieldResp, EsAggregationResp, EnsembleStateSearchFilterNot, EnsembleStateSearchFilterOr, EnsembleStateSearchFilterAnd, EnsembleStateSearchFilter, GetElasticDocumentEnsembleStatePath, GetElasticDocumentEnsembleStateQuery, GetElasticDocumentEnsembleStateResp, GetElasticDocumentEnsembleStateCountQuery, GetElasticDocumentEnsembleStateCountResp, UpdateElasticDocumentEnsembleStateRqst, UpdateElasticDocumentEnsembleStatePath, UpdateElasticDocumentEnsembleStateResp, BulkUpdateElasticDocumentEnsembleStateResp, DeleteElasticDocumentEnsembleStatePath, DeleteElasticDocumentEnsembleStateResp, SearchEnsembleStateUnfilteredRqst, SearchEnsembleStateUnfilteredResp, ExportEnsembleStateUnfilteredRqst, RegisterFilterEnsembleStateUnfilteredRqst, RegisterFilterEnsembleStateUnfilteredResp, UnregisterFilterEnsembleStateUnfilteredRqst, ChangesFeedEnsembleStateUnfilteredRqst, ListAggregationsEnsembleStateUnfilteredRqst, ListAggregationsEnsembleStateUnfilteredResp, CarrierLocation, CarrierLocationSic, CarrierMaster, FuelSurcharge, HssSchedule, InvoiceItemStaging, InvoiceStaging, Lane, Pull, PullComment, Tender, TenderDetail, TenderDetailSnapshot, TenderSnapshot, EventWait, RetriggerEvent, SymphonyMessage, SymphonyQueue, TransactionEvent, TransactionEventBusiness, TransactionEventDetail, ListEnsembleConfigurationsResp, TimerConfig, Timer, ListTimerEnsemblesPath, ListTimerEnsemblesResp, StartTimerEnsemblePath, StartTimerEnsembleResp, StopTimerEnsemblePath, StopTimerEnsembleResp, StartTenderChEnsembleRqst, StartTenderChEnsemblePath, StartTenderChEnsembleQuery, StartTenderChEnsembleResp, CmsCartageEventPayload, CarrierManagementEventPayload, HSSScheduleJMSPayload, EnsembleStateSearchRecordMessage };

